import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'intialsName'
})
export class IntialsNamePipe implements PipeTransform {
    transform(name: string, characters = 2): string {
        if (!name) return '-';
        const words = name.split(' ').filter(word => word.length > 0);
        return words
          .map(word => word[0].toUpperCase())
          .slice(0, characters)
          .join('');
      }
}